import ContentBox from './content-box';
import SplitContentBox from './split-content-box';
import TextBox from './text-box';
import VideoContent from './video-content';
import ImageBanner from './image-banner';
import InteractiveImage from './interactive-image';
import SplitImage from './split-image';
import ContentCarousel from './content-carousel';
import TextElement from './text-element';

export default {
    contentBox: ContentBox,
    splitContentBox: SplitContentBox,
    textBox: TextBox,
    video: VideoContent,
    imageBanner: ImageBanner,
    interactiveImg: InteractiveImage,
    splitImg: SplitImage,
    contentCarousel: ContentCarousel,
    textElement: TextElement
};
